import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import styled from "styled-components";

import { imgAlimentos5 } from "../../../../images/images";

export const Like = styled(ThumbUpAltIcon)`
  color: #777999;
`;

export const ContainerLike = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  margin-top: 20px;
`;
export const ContainerPerson = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 50px;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const ContainerAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerDados = styled.div`
  display: flex;
  margin: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 700px) {
    flex-direction: column;
    margin: 20px 40px;
  }
`;
export const Image = styled.img`
  max-height: 544px;
  max-width: 370px;
  width: 100%;
  height: auto;
  overflow: hidden;
  @media (max-width: 700px) {
    width: 95%;
  }
`;

export const Nome = styled.p`
  font-size: calc(2px + 1vw);
  font-weight: bold;
  align-self: center;
  margin: 0px 0px;
  text-transform: capitalize;
  text-justify: auto;
  @media (max-width: 768px) {
    font-size: calc(12px + 1vw);
  }
`;

export const Especialidade = styled.p`
  /* color: #cdcdcd; */
  font-size: calc(1px + 1vw);
  letter-spacing: 1px;
  color: #000222;
  font-weight: bold;
  align-self: center;
  /* margin: 1px 10px; */
  @media (max-width: 768px) {
    font-size: calc(12px + 1vw);
  }
`;

export const Label = styled.p`
  font-size: calc(1px + 1vw);
  font-weight: bold;
  margin: 0px 0px;
  text-justify: auto;
  letter-spacing: 1px;
  @media (max-width: 768px) {
    font-size: calc(10px + 1vw);
  }
`;

export const Informacao = styled.p`
  /* color: #cdcdcd; */
  text-align: center;
  font-size: calc(24px + 1vw);
`;

export const Curriculo = styled.p`
  margin: 40px;
`;

export const Action = styled.a`
  :link {
    color: #000;
  }
  :visited {
    color: #000;
  }
  :hover {
    color: #0001;
  }
  :active {
    color: #000;
  }
`;

/** Container Imagem */

export const ContainerBoxImage = styled.div`
  height: 100%;
  margin: 0;
  position: relative;
`;

export const ContainerBoxText = styled.div`
  /* background-color: rgb(0, 0, 0); Fallback color */
  /* background-color: rgba(0, 0, 0, 0.4); Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  /* border: 3px solid #f1f1f1; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 80%;
  padding: 20px;
  text-align: center;
`;

export const BoxImage = styled.div`
  /* The image used */
  background-image: url(${imgAlimentos5});
  /* Add the blur effect */
  filter: blur(8px);
  -webkit-filter: blur(8px);
  /* Full heigt */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
